import { ArrowUpRight } from "lucide-react";
import { useMagnetic } from "@/components/effects";

/**
 * Slim closing CTA shown at the bottom of every non-home page.
 */
export default function SlimCTA() {
  const magRef = useMagnetic(0.28);
  return (
    <section
      data-testid="slim-cta"
      className="relative py-20 md:py-24 border-y border-white/10 bg-[#080808]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-yellow-400" />
            <span className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-mono">
              Ready when you are
            </span>
          </div>
          <h3 className="font-heading text-2xl sm:text-3xl md:text-4xl font-light leading-snug tracking-tight text-white">
            Tell us the conversation
            <br />
            <span className="text-zinc-500">you'd like to automate.</span>
          </h3>
        </div>
        <div className="md:col-span-4 flex md:justify-end">
          <a
            ref={magRef}
            href="sms:+13104295413?&body=Hey%20Robbe!%20I'm%20so%20intrigued%2C%20what%20do%20you%20need%20for%20me%20to%20start%3F"
            data-testid="slim-cta-button"
            className="group inline-flex items-center gap-3 bg-yellow-400 text-black px-7 py-4 text-xs uppercase tracking-[0.22em] font-medium hover:bg-yellow-500"
          >
            Start Your Project
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
          </a>
        </div>
      </div>
    </section>
  );
}
